/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const METRIC_CDP_EVENTS = `cdp/events`;
export const METRIC_CDP_SEGMENTS = `cdp/segments`;
export const METRIC_CDP_SCV_CUSTOMERS = `cdp/scv/customers`;
